module.exports = __webpack_public_path__ + "assets/deng.8381ab84.svg";